<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  width?: string;
  height?: string;
  variant?: 'text' | 'circular' | 'rectangular';
}>();

const classes = computed(() => ({
  'ui-skeleton--text': props.variant === 'text',
  'ui-skeleton--circular': props.variant === 'circular',
  'ui-skeleton--rectangular': props.variant === 'rectangular' || !props.variant,
}));

const style = computed(() => ({
  width: props.width,
  height: props.height,
}));
</script>

<template>
  <div
    class="ui-skeleton"
    :class="classes"
    :style="style"
    aria-hidden="true"
  />
</template>

<style scoped>
.ui-skeleton {
  display: block;
  width: 100%;
  min-height: 1rem;
  overflow: hidden;
  border-radius: var(--ui-radius-sm);
  background:
    linear-gradient(
      90deg,
      transparent,
      color-mix(in srgb, var(--ui-foreground-inverse) 34%, transparent),
      transparent
    ),
    linear-gradient(90deg, var(--ui-surface-muted), var(--ui-surface-strong), var(--ui-surface-muted));
  background-position: -160% 0, 0 0;
  background-size: 55% 100%, 100% 100%;
  box-shadow: inset 0 1px 0 color-mix(in srgb, var(--ui-foreground-inverse) 20%, transparent);
  animation: ui-skeleton-pulse 1.35s ease-in-out infinite;
}

.ui-skeleton--text {
  height: 1rem;
  border-radius: var(--ui-radius-full);
}

.ui-skeleton--circular {
  border-radius: var(--ui-radius-full);
}

.ui-skeleton--rectangular {
  border-radius: var(--ui-radius-md);
}

@keyframes ui-skeleton-pulse {
  to {
    background-position: 220% 0, 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ui-skeleton {
    animation: none;
  }
}
</style>
